import { render, staticRenderFns } from "./MultipleTicket.vue?vue&type=template&id=b9fa3af6&lang=pug&"
import script from "./MultipleTicket.vue?vue&type=script&lang=js&"
export * from "./MultipleTicket.vue?vue&type=script&lang=js&"
import style0 from "./MultipleTicket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MultipleTicket.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDataTable,
  VFlex,
  VIcon,
  VLayout,
  VTooltip,
})
